type Props = {
  inStock: boolean
  size?: 'compact' | 'comfortable'
  className?: string
}

export function stockAvailabilityLabel(inStock: boolean): string {
  return inStock ? 'Stock available' : 'No stock'
}

export function StockAvailabilityBadge({ inStock, size = 'compact', className = '' }: Props) {
  const compact = size === 'compact'

  return (
    <span
      className={[
        'inline-flex w-fit max-w-full items-center gap-1.5 rounded-full border font-medium',
        compact ? 'px-2 py-0.5 text-[0.62rem]' : 'px-2.5 py-1 text-[0.6875rem]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        background: inStock ? 'var(--stock-bg-in)' : 'var(--stock-bg-out)',
        borderColor: inStock ? 'var(--stock-border-in)' : 'var(--stock-border-out)',
        color: inStock ? 'var(--stock-text-in)' : 'var(--stock-text-out)',
      }}
    >
      <span
        className={`shrink-0 rounded-full ${compact ? 'h-1.5 w-1.5' : 'h-[7px] w-[7px]'}`}
        style={{ background: inStock ? 'var(--stock-dot-in)' : 'var(--stock-dot-out)' }}
        aria-hidden
      />
      {stockAvailabilityLabel(inStock)}
    </span>
  )
}
